import { Component, HostListener, ViewChild, ElementRef } from '@angular/core'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { Router } from '@angular/router'
import { AppUsersService } from '../services/app-users.service'
export interface User {
  firstName: string
  lastName: string
  emailAddress: string
  phoneNumber: number
}
@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrl: './create-user.component.scss'
})
export class CreateUserComponent {
  hidePassword: boolean = true
  editPage: boolean = false
  userId: any
  roleDropdownOpen = false
  dropdownTop = 0
  dropdownLeft = 0
  dropdownWidth = 0

  @ViewChild('roleTrigger') roleTrigger!: ElementRef

  readonly roleOptions = [
    { value: 'admin', label: 'Admin' },
    { value: 'orderManager', label: 'Order Manager' },
    { value: 'productManager', label: 'Product Manager' },
    { value: 'stockManager', label: 'Stock Manager' },
  ]

  getRoleLabel(value: string): string {
    return this.roleOptions.find(o => o.value === value)?.label ?? value
  }

  toggleRoleDropdown(event: Event) {
    event.stopPropagation()
    if (!this.roleDropdownOpen) {
      const rect = this.roleTrigger.nativeElement.getBoundingClientRect()
      this.dropdownTop = rect.bottom + 4
      this.dropdownLeft = rect.left
      this.dropdownWidth = rect.width
    }
    this.roleDropdownOpen = !this.roleDropdownOpen
  }

  selectRole(value: string, event: Event) {
    event.stopPropagation()
    this.user.selectedRole = value
    this.roleDropdownOpen = false
  }

  @HostListener('document:click')
  closeRoleDropdown() {
    this.roleDropdownOpen = false
  }
  user = {
    firstName: '',
    lastName: '',
    emailAddress: '',
    phoneNumber: '',
    password: '',
    selectedRole: '',
    registrationDate: new Date().toISOString().split('T')[0]
  }
  constructor(
    public builderService: BuilderService,
    private router: Router,
    public appUsersService: AppUsersService,
  ) {}

  generateRandomId(): string {
    return Date.now().toString(36) + Math.random().toString(36).substring(2, 8)
  }
  onSubmit(f: any) {
    if (f.invalid) {
      return
    }

    const formValue = f.value

    const newUser = {
      firstName: formValue.firstName,
      lastName: formValue.lastName,
      emailAddress: formValue.emailAddress,
      phoneNumber: formValue.phoneNumber,
      password: formValue.password,
      selectedRole: formValue.selectedRole,
      registrationDate: new Date().toISOString().split('T')[0]
    }

    this.appUsersService.saveUser(newUser).subscribe(
      (response) => {
        let result = JSON.parse(response)
        if (result.success === false) {
          alert('Error creating user: ' + result.message)
          console.error('Error creating user:', result.message)
          return
        }
        this.router.navigate(['/users']) // Redirect after success
      },
      (error) => {
        console.error('Error creating user:', error)
      }
    )
  }
}
